import React, { useState } from "react";
import PropTypes from "prop-types";
import "./UserSystemCard.css"; // Reuse the same CSS

// Import supplier step components
import SupplierStep1Intro from "./supplierSteps/SupplierStep1Intro";
import SupplierStep2ApprovalGate from "./supplierSteps/SupplierStep2ApprovalGate";

const SupplierSystemCard = ({
  companyStructure,
  suppliersSystem,
  onChange,
}) => {
  const [cardStep, setCardStep] = useState(1);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  // Simple finish function for supplier system
  const finishFlow = () => {
    setIsCompleted(true);
    setTimeout(() => {
      setIsHidden(true);
    }, 2000);
  };

  if (isHidden) {
    return null;
  }

  if (isCompleted) {
    return (
      <div className="user-system-card slide-out-left">
        <div className="completion-container">
          <div className="green-check">✔</div>
          <h2 className="completion-title">Supplier System Complete</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="user-system-card system-card">
      {cardStep === 1 && <SupplierStep1Intro setCardStep={setCardStep} />}
      {cardStep === 2 && (
        <SupplierStep2ApprovalGate
          setCardStep={setCardStep}
          companyStructure={companyStructure}
          suppliersSystem={suppliersSystem}
          onChange={onChange}
          finishFlow={finishFlow}
        />
      )}
    </div>
  );
};

SupplierSystemCard.propTypes = {
  companyStructure: PropTypes.object,
  userSystem: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SupplierSystemCard;
